import React, { useEffect } from "react";
import { useYoutubeUrlDownload } from "@/hooks/use-youtube-url-download";
import LinkInput from "@/components/common/link-input";
import { useMediaInputContext } from "@/providers/media-input-provider/media-input-provider";

const YoutubeLinkInput = () => {
  const { handleFileChange, uploadedFiles } = useMediaInputContext();
  const { setYoutubeAudio, ...props } = useYoutubeUrlDownload({
    changeContextCallback: (audio) =>
      handleFileChange({
        type: "youtube",
        title: audio.title,
        image: audio.icon,
        songFile: audio.file,
      }),
    deleteInContextCallback: () =>
      handleFileChange({
        type: "youtube",
        title: undefined,
        image: undefined,
        songFile: undefined,
      }),
  });

  useEffect(() => {
    const youtubeData = uploadedFiles.youtube;
    const file = youtubeData?.songFile ?? undefined;
    setYoutubeAudio({
      title: youtubeData?.title ?? "",
      file: file,
      icon: youtubeData?.image ?? "",
    });
  }, [uploadedFiles.youtube]);

  return <LinkInput {...props} />;
};

export default YoutubeLinkInput;
